/* eslint-disable react/require-default-props */
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import './CopyButtonStyles.scss';
const baseClass = 'qmb-ui-copy-button';
/**
 * CopyButton Component
 * A button that copies text to the clipboard and shows brief "Copied!" feedback.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function CopyButton({ text, className }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = useCallback(() => {
        void navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    }, [text]);
    return (React.createElement("button", { type: "button", className: classNames(baseClass, { [`${baseClass}--copied`]: copied }, className), onClick: handleCopy, "aria-label": copied ? 'Copied to clipboard' : 'Copy content' },
        React.createElement("i", { className: classNames('fa-light', copied ? 'fa-check' : 'fa-copy') }),
        React.createElement("span", { className: `${baseClass}__sr-only`, "aria-live": "polite" }, copied ? 'Copied to clipboard' : '')));
}
